/**
 * API Configuration
 *
 * Central source of truth for API base URL and configuration.
 * All API calls should use these constants instead of reading env vars directly.
 */

/**
 * API base URL
 *
 * Single source of truth for the API endpoint.
 * - Default: '' = same origin — /api/* is proxied to edge-api by the
 *   ui-worker (deployed) or by the Vite dev-server proxy (npm run dev).
 * - Escape hatch: set VITE_API_URL to call an edge-api origin directly
 *   (e.g. local dev against the staging API, or bisecting the proxy).
 */
export const API_BASE_URL = import.meta.env.VITE_API_URL || '';

/**
 * Build full API URL for a given path
 *
 * @param path - API path (e.g., '/api/v1/users/me')
 * @returns Full URL (e.g., 'https://api.example.com/api/v1/users/me')
 */
export function buildApiUrl(path: string): string {
  return `${API_BASE_URL}${path}`;
}
